window.addEventListener("load", () => {
  const pdpservice = document.querySelectorAll(
    ".pdp-service"
  );

  const observerCircular = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          
          window.datLayer = window.datLayer || [];
          window.scrollBenefits = true;
          window._conv_q = window._conv_q || [];
          window._conv_q.push(["executeExperiment", "100431702"]);

        } else {
          return;
        }
      });
    },
    { threshold: 0.5 }
  );
  //
  for (let i = 0; i < pdpservice.length; i++) {
    const elements = pdpservice[i];
    observerCircular.observe(elements);
  }
});
